var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 11.5,
    fill: "#F4F6FE",
    stroke: "#1737E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 9.54395H9.04339C8.56513 9.54395 8.17818 9.93525 8.17818 10.4135L8.17383 15.6309C8.17383 16.1092 8.56513 16.5005 9.04339 16.5005H15.9999C16.4782 16.5005 16.8695 16.1092 16.8695 15.6309V10.4135C16.8695 9.93525 16.4782 9.54395 15.9999 9.54395ZM15.826 11.3918L12.7521 13.3135C12.613 13.4005 12.4304 13.4005 12.2912 13.3135L9.21731 11.3918C9.10861 11.3222 9.04339 11.2048 9.04339 11.0787C9.04339 10.7874 9.36078 10.6135 9.60861 10.7657L12.5217 12.5874L15.4347 10.7657C15.6825 10.6135 15.9999 10.7874 15.9999 11.0787C15.9999 11.2048 15.9347 11.3222 15.826 11.3918Z",
    fill: "#1737E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailA);
export default __webpack_public_path__ + "static/media/email_a.1752efab95d21c7eba1a85666834619e.svg";
export { ForwardRef as ReactComponent };